import { render, staticRenderFns } from "./RouteHistory.vue?vue&type=template&id=a778bf9c"
import script from "./RouteHistory.vue?vue&type=script&lang=js"
export * from "./RouteHistory.vue?vue&type=script&lang=js"
import style0 from "./RouteHistory.vue?vue&type=style&index=0&id=a778bf9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports